import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
  DocumentReaderContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "flex-start",
    rowGap: "12px",
    overflow: "hidden hidden",
    position: "relative",
    boxSizing: "border-box",
  },
  listContainer: {
    width: "100%",
    height: "75vh",
  },
  loadingContainer: {},
});
